import {
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE
} from "../Actions/ResetPasswordAction";

const initialState = {
    loading: false,
    error: "",
    success: false
};

const ResetPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
        case RESET_PASSWORD_REQUEST:
            return { ...state, loading: true, error: "", success: false };
        case RESET_PASSWORD_SUCCESS:
            return { ...state, loading: false, success: true };
        case RESET_PASSWORD_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default ResetPasswordReducer;
